(() => {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const animate = (node, frames, options) => { if (!reduced.matches) node.animate(frames, options); };
  document.querySelectorAll('[data-conversion]').forEach(root => {
    const image = root.querySelector('[data-cv-main-image]');
    image?.addEventListener('load', () => {
      animate(image,[{opacity:.3,transform:'translateY(8px) scale(.985)'},{opacity:1,transform:'none'}],{duration:380,easing:'cubic-bezier(.22,.8,.2,1)'});
      const selected = root.querySelector('.cv-thumbnail[aria-pressed="true"]');
      if(selected){const strip=selected.parentElement;strip.scrollTo({left:selected.offsetLeft-strip.offsetLeft-(strip.clientWidth-selected.clientWidth)/2,behavior:reduced.matches?'auto':'smooth'});}
    });
    root.querySelectorAll('.cv-accordion details').forEach(details => {
      details.addEventListener('toggle', () => {
        if(details.open) [...details.children].filter(n=>n.tagName!=='SUMMARY').forEach(n=>animate(n,[{opacity:0,transform:'translateY(-6px)'},{opacity:1,transform:'none'}],{duration:240,easing:'ease-out'}));
      });
    });
    const observer = new IntersectionObserver(entries => entries.forEach(entry=>{
      if(!entry.isIntersecting)return;
      animate(entry.target,[{opacity:.4,transform:'translateY(16px)'},{opacity:1,transform:'none'}],{duration:550,easing:'cubic-bezier(.22,.8,.2,1)'});
      observer.unobserve(entry.target);
    }),{threshold:.12});
    root.querySelectorAll('.cv-story-grid article,.pw-origin,.pw-notes-grid article,.pw-fit,.cv-final').forEach(n=>observer.observe(n));
    root.addEventListener('click',event=>{
      const link=event.target.closest('a[href^="#"]');
      if(!link||event.defaultPrevented||event.ctrlKey||event.metaKey||event.shiftKey||event.altKey)return;
      const target=document.getElementById(link.hash.slice(1));
      if(!target)return;
      event.preventDefault();
      if(target.tagName==='DETAILS')target.open=true;
      target.scrollIntoView({behavior:reduced.matches?'auto':'smooth',block:'start'});
      history.replaceState(null,'',link.hash);
      // Preserve keyboard navigation after jumping to a distant section.
      if(!target.hasAttribute('tabindex'))target.setAttribute('tabindex','-1');
      target.focus({preventScroll:true});
    });
  });
})();
